import React from "react";

import { Link, Typography } from "@mui/material";

export const GiglLongDescription = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Whether a park or common, playing field or a golf course, an allotment
        or a civic square, open spaces are important to the lives of London’s
        residents. They provide space for relaxation, for sport and recreation,
        aid mitigation for climate change and even boost the economy of the
        local area.
      </Typography>
      <Typography variant="body1" paragraph>
        Open space is defined as undeveloped land which has an amenity value, or
        has potential for an amenity value. The value could be visual, derive
        from a site’s historical or cultural interest or from the enjoyment of
        facilities which it provides. It includes both public and private
        spaces, but excludes private gardens.
      </Typography>
      <Typography variant="body1" paragraph>
        For more information about GiGL Open Spaces please visit the{" "}
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.gigl.org.uk/open-spaces/"
          underline="hover"
        >
          GiGL website
        </Link>
        .
      </Typography>
    </>
  );
};

export const giglShortDescription =
  "Greenspace Information for Greater London.";
